import React from 'react';
import { Typography, Paper, Box } from '@mui/material';

export default function EmployeeDashboard() {
  return (
    <Paper elevation={3} sx={{ p: 4, borderRadius: 3, bgcolor: 'background.paper' }}>
      <Typography variant="h4" gutterBottom sx={{ color: 'primary.main', fontWeight: 700 }}>
        员工管理后台
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        这里是员工专用的管理页面，仅限内部员工访问。后续功能会在此页面展示。
      </Typography>
      <Box sx={{ minHeight: 300, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'grey.50', borderRadius: 2 }}>
        <Typography color="text.disabled">功能开发中...</Typography>
      </Box>
    </Paper>
  );
} 